import { APP_ENV, CONNECTED_DISPLAY_ENV } from 'app/RenderingEnvironment/const';
import {
  CONTENT_HEADER,
  FIT_GUIDE_CONTAINER,
  FIT_VIDEO_CONTAINER,
  PRODUCT_RECOMMENDATIONS_SHELF,
  PROMO_TILE,
  SIZE_CHART_CONTAINER,
  SIZE_FIT_COPY,
  SIZE_FIT_IMAGES,
  SIZE_FIT_TABLE,
  SIZE_FIT_TABLE_GROUP,
  SIZE_FIT_VIDEO
} from 'lib/contract/names';

import {
  DEFAULT_CONTENT_CONTEXT,
  DEVICE,
  DISPLAY_ON_APP_ANDROID,
  DISPLAY_ON_APP_IOS,
  DISPLAY_ON_DESKTOP,
  DISPLAY_ON_MOBILE
} from './const';

/**
 * return content context object for a particular component
 * @param {object} params - params
 * @param {string} params.componentVariation - component variation
 * @param {string} params.pageType - component page type
 * @returns {object} content context
 */
export const getDefaultContentContext = function getDefaultContentContext({
  componentVariation = '',
  pageType = ''
}) {
  if ([CONTENT_HEADER, PROMO_TILE].includes(componentVariation)) {
    return {
      ...DEFAULT_CONTENT_CONTEXT,
      [DEVICE]: [DISPLAY_ON_DESKTOP]
    };
  } else if (
    APP_ENV.supportedComponents.includes(componentVariation) &&
    PRODUCT_RECOMMENDATIONS_SHELF !== componentVariation &&
    pageType === APP_ENV.name
  ) {
    return {
      ...DEFAULT_CONTENT_CONTEXT,
      [DEVICE]: [DISPLAY_ON_APP_IOS, DISPLAY_ON_APP_ANDROID]
    };
  } else if (
    [
      FIT_GUIDE_CONTAINER,
      FIT_VIDEO_CONTAINER,
      SIZE_CHART_CONTAINER,
      SIZE_FIT_COPY,
      SIZE_FIT_IMAGES,
      SIZE_FIT_TABLE,
      SIZE_FIT_TABLE_GROUP,
      SIZE_FIT_VIDEO
    ].includes(componentVariation)
  ) {
    return {
      ...DEFAULT_CONTENT_CONTEXT,
      [DEVICE]: [
        DISPLAY_ON_DESKTOP,
        DISPLAY_ON_MOBILE,
        DISPLAY_ON_APP_IOS,
        DISPLAY_ON_APP_ANDROID
      ]
    };
  } else if (CONNECTED_DISPLAY_ENV.supportedComponents.includes(componentVariation)) {
    return DEFAULT_CONTENT_CONTEXT;
  }
  return {
    ...DEFAULT_CONTENT_CONTEXT,
    [DEVICE]: [DISPLAY_ON_DESKTOP, DISPLAY_ON_MOBILE]
  };
};
